import { Check, Package } from "lucide-react";

// Card compacta (cuadrada) con "fan" apretado: el principal adelante y las otras
// asomando apenas a los costados (una a cada lado), estilo selección múltiple de ATLAS.
export function ProductStackCard({
  nombre,
  thumbs,
  count,
  listo,
  onClick,
}: {
  nombre: string;
  thumbs: string[];
  count: number;
  listo: boolean;
  onClick: () => void;
}) {
  const [main, ...rest] = thumbs;
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative text-left w-full rounded-xl border border-black/[0.08] bg-surface-card shadow-sm p-2 hover:border-neutral-300 transition-colors"
    >
      <div className="relative aspect-square mb-1.5 flex items-center justify-center">
        {rest[1] && (
          <img
            src={rest[1]}
            alt=""
            className="absolute h-[70%] w-[56%] object-cover rounded-md -rotate-[10deg] -translate-x-5 shadow-sm ring-1 ring-black/5"
          />
        )}
        {rest[0] && (
          <img
            src={rest[0]}
            alt=""
            className="absolute h-[70%] w-[56%] object-cover rounded-md rotate-[10deg] translate-x-5 shadow-sm ring-1 ring-black/5"
          />
        )}
        {main ? (
          <img
            src={main}
            alt=""
            className="relative h-[78%] w-[60%] object-cover rounded-md shadow-md ring-2 ring-white"
          />
        ) : (
          <div className="relative h-[78%] w-[60%] rounded-md bg-neutral-100 flex items-center justify-center ring-2 ring-white">
            <Package className="w-4 h-4 text-brand-black/25" />
          </div>
        )}
      </div>
      <div className="flex items-center justify-between gap-1">
        <span className="text-[12.5px] font-medium text-brand-black/80 truncate">
          {nombre}
        </span>
        {listo && (
          <span className="w-4 h-4 rounded-full bg-emerald-500 text-white inline-flex items-center justify-center shrink-0">
            <Check className="w-2.5 h-2.5" />
          </span>
        )}
      </div>
      <span className="text-[11px] text-neutral-500">
        {count} {count === 1 ? "foto" : "fotos"}
      </span>
    </button>
  );
}

export default ProductStackCard;
